<template>
  <div class="prebuy">
    {{ dateFormater(time, 'MM-dd hh:mm') }} 尾款期结束 <span>付尾款 ￥{{ price }}</span>
  </div>
</template>
<script>
import { dateFormater } from 'utils/date';

export default {
  props: ['time', 'price'],
  methods: {
    dateFormater,
  },
};
</script>
<style lang="scss" scoped>
.prebuy {
  height: 48px;
  line-height: 48px;
  display: inline-block;
  padding: 0 10px;
  border-radius: 11px;
  border: 1px solid #FF5400;
  font-size: 20px;
  color: #FF5400;

  span {
    font-size: 22px;
    font-weight: 500;
    margin-left: 14px;
  }
}
</style>
